export default __webpack_public_path__ + "static/media/trade-in__manager3.f322484c.jpg";